<template>
  <el-card class="card" shadow="hover">
    <div class="content">
      <div class="logo" :style="{ 'background-image': `url(${require('@/assets/img/agreement_cover.png')})` }"></div>
      <div class="agreement-detail">
        <slot :agreement="data">使用平台审方功能前，请先签署该协议</slot>
      </div>
    </div>
    <p class="text">{{ data.name }}</p>
    <div :class="buttonCls" @click="link">{{ buttonText }}</div>
  </el-card>
</template>

<script>
import Vue from 'vue';
import { Card } from 'element-ui';
import classNames from 'classnames';

Vue.use(Card);

export default {
  name: 'agreementCard',
  props: {
    data: Object,
    type: String,
    buttonText: {
      type: String,
      default: '立即签署'
    }
  },
  computed: {
    buttonCls() {
      return classNames('button', this.type);
    }
  },
  methods: {
    link() {
      const {
        data: { id }
      } = this;
      this.$parent.$emit('link', id);
    }
  }
};
</script>

<style lang="scss" scoped>
$primaryColor: #1e8dff;

.card {
  margin-right: 16px;
  margin-bottom: 16px;
  width: 176px;

  /deep/.el-card__body {
    padding: 0;
  }

  &:hover {
    .content {
      .agreement-detail {
        max-height: 500px;
        opacity: 1;
        visibility: visible;
        transition: all 1s;
      }
    }
  }

  .content {
    position: relative;
    padding: 14px 10px 0;

    .logo {
      margin-bottom: 8px;
      width: 100%;
      height: 133px;
      background-size: 100%;
    }

    .agreement-detail {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 5;
      padding: 6px 7px;
      width: 100%;
      font-size: 10px;
      color: #fff;
      line-height: 14px;
      visibility: hidden;
      opacity: 0;
      max-height: 0;
      background: rgba(35, 61, 41, 0.4);
    }
  }

  .text {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-bottom: 16px;
    padding: 0 19px;
    height: 40px;
    font-size: 14px;
    color: #242424;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 32px;
    font-size: 12px;
    color: #fff;
    background-color: $primaryColor;
    cursor: pointer;

    &.finish {
      font-size: 12px;
      color: $primaryColor;
      border-top: 1px solid rgba(242, 242, 242, 1);
      background-color: #fff;
    }
  }
}
</style>
